import { useRegisterSW } from 'virtual:pwa-register/react'
import * as Sentry from '@sentry/react'
import { cn } from '@/utils'
import { Button } from '../../../components/button'

export function UpdateBanner() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      console.info('[SW] Service Worker registered:', swUrl)
      console.info('[SW] Registration state:', registration?.active?.state)

      if (registration) {
        const checkForUpdates = () => {
          console.info('[SW] Checking for updates')
          registration.update().catch((err) => console.error('[SW] Update check failed:', err))
        }

        // Check immediately on page load
        checkForUpdates()

        // Check when window regains focus
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') checkForUpdates()
        })

        // Check periodically (every 3 minutes)
        const intervalMs = 1000 * 60 * 3
        setInterval(checkForUpdates, intervalMs)
      }
    },
    onNeedRefresh() {
      console.info('[SW] New static files available')
    },
    onRegisterError(error) {
      console.error('[SW] Registration failed:', error)
      Sentry.captureException(error, {
        tags: { feature: 'pwa' },
        extra: { message: 'Service Worker registration failed' },
      })
    },
  })

  const refresh = async () => {
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      // Register listener BEFORE activating the new SW — controllerchange fires
      // immediately when the new SW takes control, so attaching after the await misses it.
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload()
      }, { once: true })
      await updateServiceWorker(true)
    } else {
      await updateServiceWorker(true)
      window.location.reload()
    }
  }

  return (
    <div
      className={cn(
        'flex items-center gap-4 rounded-sm shadow-sm bg-gray-800 px-5 py-3',
        needRefresh
          ? 'fixed bottom-10 left-10 z-2000'
          : 'hidden pointer-events-none',
      )}
    >
      <div className="flex-1">
        <p className="text-lg font-semibold">System Update</p>
        <p className="text-sm text-gray-500">
          Please refresh the page to apply the update.
        </p>
      </div>
      <Button
        onClick={refresh}
        text="Refresh"
      />
    </div>
  )
}
